// UI-only constants used in HpeStrategyStep display math.
// The calculation engine has moved server-side; only these display-layer values remain.
export const HPE_DEDUCTION_MULTIPLIER = 2.49;   // $1 invested = $2.49 deduction
export const CHARITABLE_NONCASH_AGI_CAP = 0.50; // 50% of AGI max for non-cash charitable
